import { render, staticRenderFns } from "./NotificationBasic.vue?vue&type=template&id=14c532bc&scoped=true&"
import script from "./NotificationBasic.vue?vue&type=script&lang=js&"
export * from "./NotificationBasic.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBasic.vue?vue&type=style&index=0&id=14c532bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c532bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
